module.exports = __webpack_public_path__ + "home-main-graphic-with-bg.1fRu__I-.png";